import axios from "axios";
import API from "../helpers/api";
let searchData = {
  Mail: '',
  PageNumber: 1,
  PageSize: 15
}
let currentUser = JSON.parse(localStorage.getItem("currentUser"));
export const AddUserDetails = (data) => {
  let url = `${API.UserAPI}`;
  return dispatch => {
    axios.post(url, data).then((response) => {
      dispatch({
        type: 'PostUserSuccess',
        data: response.data
      })
    }).catch((error) => {
      dispatch({
        type: 'PostUserFailure',
        data: "error"
      })

    })
  }
}
export const updateUserDetails = (data) => {
  let url = `${API.UserAPI}`;
  return dispatch => {
    axios.put(url, data)
      .then((response) => {
        dispatch({
          type: "UpdateUserSuccess",
          data: response.data
        })
      })
      .catch((error) => {
        dispatch({
          type: "UpdateUserFailure",
          error: "ERROR"
        })
      })
  }
}
export const getUsersList = (searchItem) => {
  let url = `${API.getUser}?Mail=${searchItem.Mail}&PageNumber=${searchItem.PageNumber}&PageSize=${searchItem.PageSize}`;
  return dispatch => {
    axios.get(url)
      .then((response) => {
        dispatch({
          type: "getUserDataSuccess",
          data: response.data
        })
      })
      .catch((error) => {
        dispatch({
          type: "getUserDataFailure",
          error: "ERROR"
        })
      })
  }
}

export const deleteUserListDetails = (data) => {
  let url = `${API.UserAPI}`;
  return dispatch => {
    axios.put(url, data, {
      headers: {
        key: currentUser.accessToken
      }
    })
      .then((response) => {
        dispatch(getUsersList(searchData));
        dispatch({
          type: "deleteUserListDetailsSuccess",
          data: response.data,
        })
      })
      .catch((error) => {
        dispatch({
          type: "deleteUserListDetailsFailure",
          error: "ERROR"
        })
      })
  }
}

export const getUserDetails = (id) => {
  let url = `${API.getUserDetail}?userid=${id}`;
  return dispatch => {
    axios.get(url)
      .then((response) => {
        dispatch({
          type: "getUserDetailsSuccess",
          data: response.data
        })
      })
      .catch((error) => {
        dispatch({
          type: "getUserDetailsFailure",
          error: "ERROR"
        })
      })
  }
}
export const getshipNameList = (searchItem) => {
  let url = `${API.shipNames}`;
  return dispatch => {
    axios.get(url)
      .then((response) => {
        dispatch({
          type: "getshipNameListSuccess",
          data: response.data
        })
      })
      .catch((error) => {
        dispatch({
          type: "getshipNameListFailure",
          error: "ERROR"
        })
      })
  }
}

